export const actionsFor = (mode, deps)=>{
    const { dismissModal, backToUpload, texts, TID } = deps;
    if (mode.kind === 'result') {
        return {
            secondaryLabel: texts.actions.close(),
            secondaryTestId: TID.CloseButton(),
            onSecondary: dismissModal,
            primaryBi: 'import_clients_primary_noop',
            secondaryBi: 'import_clients_close'
        };
    }
    if (mode.kind === 'blockingError') {
        if (mode.errorKind === 'unreadableFile') {
            return {
                primaryLabel: texts.actions.uploadAnotherFile(),
                primaryTestId: TID.UploadAnotherFileButton(),
                onPrimary: backToUpload,
                primaryBi: 'import_clients_upload_another',
                secondaryLabel: texts.actions.close(),
                secondaryTestId: TID.CloseButton(),
                onSecondary: dismissModal,
                secondaryBi: 'import_clients_close'
            };
        }
        return {
            secondaryLabel: texts.actions.close(),
            secondaryTestId: TID.CloseButton(),
            onSecondary: dismissModal,
            primaryBi: 'import_clients_primary_noop',
            secondaryBi: 'import_clients_close'
        };
    }
    return {
        primaryBi: 'import_clients_primary_noop',
        secondaryBi: 'import_clients_secondary_noop'
    };
};
